interface Props {
  className?: string;
}

export function Separator({ className = '' }: Props): JSX.Element {
  return <div className={`co-bg-gray-300 co-h-px ${className}`} />;
}
